import { CHECK_AUTH_TOKEN } from './constant';

export const checkAuthTokenAction = (token: string) => {
  return { type: CHECK_AUTH_TOKEN, token }
}